// extracted by mini-css-extract-plugin
export default {"containerLandingPagePrakerja":"style_containerLandingPagePrakerja__Oftoj","backgroundPrakerja":"style_backgroundPrakerja__sYVnz"};